@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=Syne:wght@700;800&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --bg: #eef3f8;
  --card: #ffffff;
  --line: #d9e2ec;
  --ink: #1b2a3d;
  --muted: #5b6b7c;
  --navy: #163a5f;
  --income: #2f6fed;
  --expense: #e8b923;
  --margin: #c0392b;
  --good: #1f8a4c;
  --bad: #c0392b;
  --even: #e67e22;
  --chip: #f4f8fc;
  --font-display: 'Syne', 'Avenir Next', sans-serif;
  --font-body: 'IBM Plex Sans', 'Segoe UI', sans-serif;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body,
#root {
  min-height: 100%;
}

body {
  margin: 0;
  color: var(--ink);
  background: var(--bg);
  font-family: var(--font-body);
  -webkit-font-smoothing: antialiased;
}

.display {
  font-family: var(--font-display);
  font-weight: 700;
  letter-spacing: -0.04em;
}

.tabular {
  font-variant-numeric: tabular-nums;
}

.page-shell {
  width: min(1200px, calc(100% - 32px));
  margin-inline: auto;
}

.site-header {
  position: sticky;
  top: 0;
  z-index: 40;
  padding: 14px 16px 12px;
  background: linear-gradient(180deg, #eceff3 0%, rgba(236, 239, 243, 0.72) 62%, transparent 100%);
  isolation: isolate;
}

.site-nav {
  position: relative;
  width: min(1200px, 100%);
  margin-inline: auto;
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 64px;
  padding: 6px 10px 6px 6px;
  background: #1b1f24;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 999px;
  box-shadow: 0 18px 40px rgba(11, 11, 11, 0.28);
}

.brand-switch {
  position: relative;
  flex: 0 0 auto;
}

.brand-lockup {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding: 2px;
  background: #fff;
  border: 0;
  border-radius: 999px;
  text-decoration: none;
  box-shadow: 0 1px 2px rgba(16, 38, 61, 0.08);
  cursor: pointer;
}

.company-menu {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  z-index: 60;
  min-width: 280px;
  padding: 8px;
  background: #1b1f24;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  box-shadow: 0 18px 40px rgba(11, 11, 11, 0.35);
}

.company-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: #fff;
  text-align: left;
  padding: 6px;
  cursor: pointer;
}

.company-option[aria-checked='true'] {
  background: rgba(255, 255, 255, 0.08);
}

.company-option-mark {
  width: 36px;
  height: 36px;
}

.company-name,
.company-account {
  display: block;
}

.company-name {
  font-size: 14px;
  font-weight: 600;
}

.company-account {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.62);
}

.drawer-companies {
  display: grid;
  gap: 6px;
  margin-bottom: 12px;
}

.brand-mark {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: contain;
  background: #fff;
}

.nav-links {
  display: none;
  flex: 1 1 auto;
  justify-content: center;
  gap: 4px;
}

.nav-link {
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  font-weight: 500;
  padding: 8px 14px;
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;
}

.nav-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.nav-link[aria-current='page'] {
  color: #1b1f24;
  background: #fff;
  font-weight: 600;
}

.nav-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

.nav-date-desktop {
  display: none;
}

.auth-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.auth-chip-primary {
  background: #fff;
  color: #1b1f24;
}

.site-nav .auth-chip {
  display: none;
}

.auth-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: cover;
}

.nav-toggle {
  height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: 999px;
  background: #fff;
  color: #1b1f24;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.site-drawer {
  position: absolute;
  top: calc(100% - 2px);
  right: 16px;
  left: auto;
  width: min(400px, calc(100% - 32px));
  margin: 0;
  padding: 16px 16px 18px;
  background: #1b1f24;
  border-radius: 28px;
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.35);
  z-index: 50;
}

.drawer-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.drawer-close {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.drawer-links {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 4px 14px;
}

.drawer-link {
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.82);
  font-size: 16px;
  text-align: left;
  padding: 10px 8px;
  border-radius: 12px;
  cursor: pointer;
}

.drawer-link[aria-current='page'] {
  color: #1b1f24;
  background: #fff;
  font-weight: 600;
}

.drawer-auth {
  width: 100%;
  justify-content: center;
  height: 44px;
  margin-top: 12px;
}

.site-drawer .auth-chip {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.site-drawer .auth-chip-primary {
  background: #fff;
  color: #1b1f24;
}

.date-range-picker {
  position: relative;
}

.drp-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.drp-trigger-icon {
  font-size: 14px;
  line-height: 1;
}

.site-drawer .drp-trigger {
  width: 100%;
  justify-content: flex-start;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.drp-popover {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 60;
  display: grid;
  grid-template-columns: 148px minmax(0, 1fr);
  gap: 0;
  min-width: min(620px, calc(100vw - 32px));
  min-height: 360px;
  padding: 16px;
  background: #1b1f24;
  border-radius: 18px;
  box-shadow: 0 24px 56px rgba(0, 0, 0, 0.35);
  color: #e8edf2;
}

.date-range-picker.is-compact .drp-popover {
  position: relative;
  top: 10px;
  right: auto;
  width: 100%;
  min-width: 0;
  grid-template-columns: 1fr;
}

.drp-presets {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-right: 12px;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}

.date-range-picker.is-compact .drp-presets {
  flex-direction: row;
  flex-wrap: wrap;
  padding-right: 0;
  padding-bottom: 10px;
  border-right: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.drp-preset {
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  text-align: left;
  padding: 9px 10px;
  cursor: pointer;
}

.drp-preset[aria-pressed='true'] {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-weight: 600;
}

.drp-calendars {
  padding-left: 12px;
  min-width: 0;
}

.date-range-picker.is-compact .drp-calendars {
  padding-left: 0;
  padding-top: 10px;
}

.drp-cal-nav {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}

.drp-nav-btn {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
}

.drp-month-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.date-range-picker.is-compact .drp-month-grid {
  grid-template-columns: 1fr;
}

.drp-month-title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

.drp-weekdays,
.drp-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.drp-weekdays span {
  text-align: center;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  padding: 4px 0;
}

.drp-day {
  height: 38px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  cursor: pointer;
}

.drp-day.is-empty {
  visibility: hidden;
  pointer-events: none;
}

.drp-day.is-future {
  color: rgba(255, 255, 255, 0.28);
  cursor: not-allowed;
}

.drp-day.is-mid {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 0;
}

.drp-day.is-edge {
  background: #fff;
  color: #111;
  font-weight: 700;
}

.drp-day.is-asof:not(.is-edge) {
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
}

@media (min-width: 960px) {
  .nav-links,
  .nav-date-desktop,
  .site-nav .auth-chip {
    display: flex;
  }

  .nav-toggle,
  .site-drawer {
    display: none;
  }
}

main.page-shell {
  padding-block: 24px;
}

.card {
  background: var(--card);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(22, 58, 95, 0.04), 0 8px 20px rgba(22, 58, 95, 0.05);
}

.pnl,
.statement {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #243447;
}

.pnl-hero {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: stretch;
}

.kpi-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(3, minmax(92px, 1fr));
  gap: 12px;
}

.kpi-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.kpi-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 1px 2px rgba(22, 58, 95, 0.04), 0 8px 20px rgba(22, 58, 95, 0.05);
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.kpi-label {
  margin: 0;
  font-size: 13px;
  color: #6b7c8d;
  line-height: 1.3;
}

.kpi-value {
  margin: 10px 0 0;
  font-size: 28px;
  font-weight: 600;
  color: #1d2b3a;
  line-height: 1.1;
  letter-spacing: -0.03em;
}

.kpi-hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: #6b7c8d;
  line-height: 1.3;
}

.kpi-row .kpi-value {
  font-size: clamp(18px, 2vw, 24px);
}

.chart-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px 18px 8px;
  box-shadow: 0 1px 2px rgba(22, 58, 95, 0.04), 0 8px 20px rgba(22, 58, 95, 0.05);
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.chart-card-pad {
  padding-bottom: 18px;
}

.chart-title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  color: #243447;
}

.chart-body {
  position: relative;
  flex: 1 1 auto;
  width: 100%;
  min-height: 280px;
  height: 320px;
}

.chart-body-sm {
  min-height: 240px;
  height: 260px;
}

.donut-row {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  align-items: center;
  gap: 16px;
  height: 260px;
}

.donut-plot {
  position: relative;
  width: 220px;
  height: 220px;
}

.donut-plot > div,
.donut-plot canvas {
  width: 220px !important;
  height: 220px !important;
}

.donut-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: 0;
}

.donut-legend li {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 13px;
  color: #5b6b7c;
}

.donut-legend .swatch {
  width: 8px;
  height: 8px;
  border-radius: 99px;
  flex: 0 0 auto;
}

.donut-legend .name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.donut-legend .amt {
  margin-left: auto;
  color: #1d2b3a;
  font-weight: 600;
}

.donut-legend .total {
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid var(--line);
  font-weight: 600;
  color: #1d2b3a;
}

.pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
}

.pager button {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fff;
  color: var(--muted);
  font-size: 13px;
  cursor: pointer;
}

.pager button[aria-current='page'] {
  background: var(--navy);
  border-color: var(--navy);
  color: #fff;
  font-weight: 600;
}

.pnl-bottom {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: stretch;
}

.pnl-bottom > .chart-card {
  height: 100%;
}

.drop-zone {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.entry-form {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 12px;
}

.entry-form > button[type='submit'] {
  margin-top: auto;
}

.table-head {
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7c8d;
  border-bottom: 1px solid var(--line);
}

.table-head th {
  padding: 10px 12px;
  font-weight: 600;
}

.table-head th.num {
  text-align: right;
}

.data-table {
  width: 100%;
  font-size: 14px;
}

.data-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
}

.data-table tbody tr:last-child td {
  border-bottom: 0;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0;
  color: var(--muted);
  font-size: 14px;
}

@media (min-width: 720px) {
  .kpi-row {
    grid-template-columns: 1fr 1fr;
  }
}

@media (min-width: 960px) {
  .pnl-hero {
    grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);
  }

  .kpi-grid {
    height: 100%;
  }

  .kpi-row {
    grid-template-columns: repeat(4, 1fr);
  }

  .chart-body {
    min-height: 0;
    height: auto;
  }

  .pnl-bottom {
    grid-template-columns: 1fr 1fr;
  }

  .chart-body-sm {
    flex: 0 0 auto;
    height: 260px;
    min-height: 260px;
  }

  .chart-body.pie-body {
    flex: 0 0 260px;
    height: 260px;
    min-height: 260px;
    max-height: 260px;
  }
}

.nav-tab {
  position: relative;
  padding: 12px 4px;
  color: var(--muted);
  font-size: 14px;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.nav-tab[aria-current='page'] {
  color: var(--navy);
  font-weight: 600;
}

.nav-tab[aria-current='page']::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 3px;
  background: var(--navy);
  border-radius: 2px 2px 0 0;
}

input,
select,
textarea,
button {
  font-family: inherit;
}

input,
select {
  background: #fff;
  color: var(--ink);
  border: 1px solid var(--line);
  border-radius: 8px;
}

input:focus,
select:focus {
  outline: 2px solid rgba(47, 111, 237, 0.35);
  outline-offset: 1px;
}

::placeholder {
  color: #8a97a6;
}

.delta-up {
  color: var(--good);
}

.delta-down {
  color: var(--bad);
}

.amount-in {
  color: var(--good);
  font-weight: 600;
}

.amount-out {
  color: var(--bad);
  font-weight: 600;
}

.pct-good {
  color: var(--good);
  font-weight: 700;
}

.pct-bad {
  color: var(--bad);
  font-weight: 700;
}

.pct-even {
  color: var(--even);
  font-weight: 700;
}

.row-total td {
  font-weight: 700;
}

.track-bar {
  height: 8px;
  border-radius: 99px;
  background: #edf2f7;
  overflow: hidden;
}

.track-bar > span {
  display: block;
  height: 100%;
  border-radius: 99px;
}

.signin-screen {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px 16px;
  background: #eceff3;
}

.signin-card {
  width: min(420px, 100%);
  padding: 36px 28px 32px;
  background: #1b1f24;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 28px;
  box-shadow: 0 24px 56px rgba(11, 11, 11, 0.28);
  text-align: center;
  color: #e8edf2;
}

.signin-mark {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: contain;
  background: #fff;
}

.signin-title {
  margin: 16px 0 8px;
  font-size: 28px;
  color: #fff;
}

.signin-copy {
  margin: 0 0 24px;
  color: rgba(255, 255, 255, 0.68);
  font-size: 14px;
  line-height: 1.45;
}

.signin-gis {
  display: flex;
  justify-content: center;
  min-height: 44px;
}

.signin-error {
  margin: 16px 0 0;
  color: #f6c98a;
  font-size: 13px;
  line-height: 1.4;
}
